import React, { useEffect, useRef, useState } from "react";
import { NavBar as AntNavBar, SafeArea, Image } from "antd-mobile";
import useRouter from "@/hooks/useRouter";
import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";
interface FixedNavBarProps {
	title?: React.ReactNode | string;
	onLeftClick?: () => void;
	rightContent?: React.ReactNode[];
	background?: string;
	seat?: boolean;
	backArrow?: boolean;
	replacePage?: string;
}
const FixedNavBar: React.FC<FixedNavBarProps> = ({
	title,
	onLeftClick,
	rightContent = [],
	background,
	seat = true,
	backArrow = true,
	replacePage = "",
}) => {
	const classes = useStyles();
	const styles = {
		background: "var(--color-031c2c)",
	};
	if (background) {
		styles["background"] = background;
	}
	const { goBack } = useRouter();

	const [fixedHeight, setFixedHeight] = useState(0);
	const fixedElementRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const handleResize = () => {
			if (fixedElementRef.current) {
				const height = fixedElementRef.current.offsetHeight;
				setFixedHeight(height);
			}
		};
		setTimeout(() => {
			handleResize();
		}, 300);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const isReactElement = (
		node: React.ReactNode
	): node is React.ReactElement => {
		return React.isValidElement(node);
	};
	return (
		<div style={{ minHeight: pxToRem(46) }}>
			<div
				ref={fixedElementRef}
				className={classes.navbarBody}
				style={styles}
			>
				<div style={{ background: "var(--color-031c2c)" }}>
					<SafeArea position="top" />
				</div>
				<AntNavBar
					backArrow={
						backArrow ? (
							<Image
								src={require("@/assets/images/icons/back.png")}
								width={20}
								height={18}
							/>
						) : null
					}
					right={rightContent}
					onBack={() => {
						onLeftClick && onLeftClick();
						goBack(replacePage);
					}}
				>
					{title && isReactElement(title) ? (
						title
					) : (
						<span className="title">{title}</span>
					)}
				</AntNavBar>
			</div>
			{seat && (
				<div
					className="placeholder"
					style={{ height: fixedHeight }}
				></div>
			)}
		</div>
	);
};

export default FixedNavBar;
const useStyles = createUseStyles({
	navbarWrap: {
		position: "fixed",
		top: 0,
		right: 0,
		left: 0,
		zIndex: 99,
		color: "white",
		paddingLeft: pxToRem(15),
		paddingRight: pxToRem(15),
		transform: "translateZ(0)",
	},
	navbarBody: {
		position: "fixed",
		top: 0,
		right: 0,
		left: 0,
		zIndex: 99,
		color: "white",
		"& .title": {
			fontSize: pxToRem(18),
			fontWeight: 600,
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
		},
	},
});

// <FixedNavBar
// 	title="Afiliado"
// 	key="Afiliado"
// 	onLeftClick={() => {}}
// 	rightContent={[
// 		<span
// 			key="af-r"
// 			onClick={() =>
// 				customNavigate(`/`, {
// 					replace: true,
// 				})
// 			}
// 			className="iconfont icon-home-line router-link-active"
// 			style={{ fontSize: ".24rem" }}
// 		></span>,
// 	]}
// />;
